const alpha = (hex: string, alpha: number) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  if (!result) {
    return null;
  }

  return `rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, ${alpha})`;
};

export default {
  alpha,
  brand: { primary: '#ffbc00' },
  red: ['#fff1f0', '#ffccc7', '#ffa39e', '#ff7875', '#ff4d4f', '#f5222d', '#cf1322', '#a8071a', '#820014', '#5c0011'],
  gray: [
    '#ffffff', // code 0 -> equivalent 1 in design
    '#fafafa', // code 1 -> equivalent 2 in design
    '#f5f5f5', // code 2 -> equivalent 3 in design
    '#f0f0f0', // code 3 -> equivalent 4 in design
    '#d9d9d9', // code 4 -> equivalent 5 in design
    '#bfbfbf', // code 5 -> equivalent 6 in design
    '#8c8c8c', // code 6 -> equivalent 7 in design
    '#595959', // code 7 -> equivalent 8 in design
    '#434343', // code 8 -> equivalent 9 in design
    '#262626', // code 9 -> equivalent 10 in design
    '#1f1f1f', // code 10 -> equivalent 11 in design
    '#141414', // code 11 -> equivalent 12 in design
    '#000000' // code 12 -> equivalent 13 in design
  ]
};
